import React from "react";
import { centeringBox } from "components/Container";
import { Page } from "components/Page";

export const FullPage = ({ children }) => {
  return (
    <Page>
      <div style={centeringBox}>
        <div
          data-testid="tos-fullpage"
          style={{
            lineHeight: "1.35em",
            height: "100%",
            padding: "8px",
          }}
        >
          {children}
        </div>
      </div>
    </Page>
  );
};
